// Custom error types for better error handling
export default class ApiError extends Error {
    constructor(
        message: string,
        public status?: number,
        public code?: string,
        public originalError?: unknown,
    ) {
        super(message);
        this.name = 'ApiError';
    }
}
